// src/hooks/useNoteEditor.js - Refactored for workspace architecture
import { useState, useEffect, useCallback, useRef } from 'react';
import { useWorkspaces } from '../components/contexts/WorkspacesContext';  // ✅ FIXED: removed extra quote

const useNoteEditor = ({ onImageUpload } = {}) => {
  const {
    selectedDocumentPublicId,      // ✅ RENAMED: was selectedNotePublicId
    getSelectedDocument,            // ✅ RENAMED: was getSelectedNote
    updateDocumentContent,          // ✅ RENAMED: was updateNoteContent
    updateDocumentTitle,            // ✅ RENAMED: was updateNoteTitle
    updateWorkspaceCategory,        // ✅ RENAMED: was updateNoteCategory
    refreshDocumentImages,          // ✅ RENAMED: was refreshNoteImages (if this exists)
  } = useWorkspaces();

  const [document, setDocument] = useState(null);  // ✅ RENAMED: was note
  const [isLoading, setIsLoading] = useState(false);
  const [contentLoaded, setContentLoaded] = useState(false);

  // Update imagesRef to use documentPublicId
  const imagesRef = useRef({
    refreshImages: async () => {
      console.log('useNoteEditor: refreshImages called');
      if (!selectedDocumentPublicId) return [];
      
      // ✅ UPDATED: If refreshDocumentImages exists, use it
      if (refreshDocumentImages) {
        const images = await refreshDocumentImages(selectedDocumentPublicId);
        onImageUpload?.(images);
        return images;
      }
      return [];
    },
    images: []
  });

  // Load document when selectedDocumentPublicId changes
  useEffect(() => {
    if (!selectedDocumentPublicId) {
      setDocument(null);
      setIsLoading(false);
      return;
    }
    
    const currentDocument = getSelectedDocument();
    if (currentDocument) {
      setDocument(currentDocument);
      // Only show loading if we have a document but no content
      setIsLoading(!currentDocument.content || currentDocument.content === '');
      setContentLoaded(!!currentDocument.content);
    }
  }, [selectedDocumentPublicId, getSelectedDocument]);

  // Handle content changes - use documentPublicId
  const handleNoteChange = useCallback((content) => {
    updateDocumentContent(selectedDocumentPublicId, content);
    setDocument(prev => prev ? { ...prev, content } : null);
  }, [selectedDocumentPublicId, updateDocumentContent]);

  // Handle title changes - use documentPublicId
  const handleTitleChange = useCallback((title) => {
    updateDocumentTitle(selectedDocumentPublicId, title);
    setDocument(prev => prev ? { ...prev, title } : null);
  }, [selectedDocumentPublicId, updateDocumentTitle]);

  // Handle category changes - use documentPublicId
  const handleCategoryChange = useCallback((categoryId) => {
    // Get current document to find its workspace
    const currentDocument = getSelectedDocument();
    if (currentDocument && currentDocument.workspace_public_id) {
      updateWorkspaceCategory(currentDocument.workspace_public_id, categoryId);
      setDocument(prev => prev ? { ...prev, primary_category_id: parseInt(categoryId) } : null);
    }
  }, [getSelectedDocument, updateWorkspaceCategory]);

  return {
    note: document,                        // ✅ Keep 'note' for backward compatibility with components
    document,                              // ✅ Also expose as 'document' for clarity
    noteId: selectedDocumentPublicId,      // ✅ Keep 'noteId' for backward compatibility
    documentId: selectedDocumentPublicId,  // ✅ Also expose as 'documentId' for clarity
    imagesRef,
    handleNoteChange,
    handleTitleChange,
    handleCategoryChange
  };
};

export default useNoteEditor;